// @catalog F.006
/**
 * Paleta de colores personalizada MásXPieza
 * Basada en los colores del logo según PLANIFICACION-SISTEMA.md
 *
 * Extensión chart.* (Bloque 1 plan dashboard_ux_ventas_margenes 2026-05-21):
 * tokens aditivos para gráficos de /ventas y /margenes — derivados de los primarios
 * recomendados en dashboard.controller.ts y de los semánticos success/error.
 * NO modifica primary/secondary/info/success/warning/error existentes.
 */

// Colores principales del logo MásXPieza
export const primaryBlue = "#0654ad";
export const accentOrange = "#984b07";

// Tokens chart.* — derivados aditivos para LineChart/Area de ventas y margenes.
// Verificable: ningún token reemplaza primarios; son consumidos solo en
// frontend/src/components/{Ventas,Margenes}/** + theme/components.
const chartTokens = {
  primaryLine: "#6B9BD2",
  previousYearLine: "rgba(117, 117, 117, 0.5)",
  projectionArea: "rgba(107, 155, 210, 0.18)",
  growthPositive: "#27AE60",
  growthNegative: "#E74C3C",
  gridLine: "#E0E0E0",
};

// Escala de grises del sistema
export const greyScale = {
  900: "#000000",
  800: "#222222ff",
  700: "#424242",
  600: "#616161",
  500: "#757575",
  400: "#9E9E9E",
  300: "#BDBDBD",
  200: "#E0E0E0",
  100: "#F5F5F5",
  50: "#FAFAFA",
  0: "#FFFFFF",
};

// Configuración de paleta Material-UI
export const palette = {
  mode: "light" as const,

  primary: {
    main: greyScale[800],
    light: greyScale[50],
    dark: greyScale[800],
    contrastText: "#FFFFFF",
  },

  secondary: {
    main: accentOrange,
    light: "#b8600a",
    dark: "#7a3d05",
    contrastText: "#FFFFFF",
  },

  grey: greyScale,

  background: {
    default: greyScale[50],
    paper: greyScale[0],
  },

  text: {
    primary: greyScale[800],
    secondary: greyScale[600],
  },

  divider: greyScale[200],

  success: {
    main: "#27AE60",
    light: "#58D68D",
    dark: "#1E8449",
  },

  warning: {
    main: "#F39C12",
    light: "#F8C471",
    dark: "#B7950B",
  },

  error: {
    main: "#E74C3C",
    light: "#EC7063",
    dark: "#C0392B",
  },

  info: {
    main: primaryBlue,
    light: "#4a7bc4",
    dark: "#043e85",
  },

  chart: chartTokens,
};

// Module augmentation: extiende Palette/PaletteOptions de MUI para que
// theme.palette.chart sea type-safe en sx={{ color: 'chart.primaryLine' }} y
// en accesos directos. Aditivo — no toca campos existentes del Palette de MUI.
declare module "@mui/material/styles" {
  interface Palette {
    chart: typeof chartTokens;
  }
  interface PaletteOptions {
    chart?: typeof chartTokens;
  }
}
